import gsap from 'gsap';
/**
 * JS to run on every page using the child theme.
 */

(function (Drupal, drupalSettings) {
  Drupal.behaviors.desktopNavButton = {
    attach: function (context, settings) {
      once('navigationScript', '.desktop-nav li.level-1.has-childs', context).forEach((item) => {
        const childMenu = item.querySelector('ul');
        const btn = item.querySelector('button');
        const spn = item.querySelector('span');
        // For accessibility we don't need span. Instead of it add button from menu.html.twig template.
        if (spn) {
          item.querySelector('span').remove();
        }

        // Event for setting the attribute accordingly set visibility of submenu on click.
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          this.setAttribute('aria-expanded', !isExpanded);
          if (isExpanded) {
            item.classList.remove('active');
            childMenu.style.display = 'none';
          } else {
            item.classList.add('active');
            childMenu.style.display = 'block';
          }
        });

      });
    }
  };
})(Drupal, drupalSettings);


class CTEKChildTheme extends DrupalBehavior {

  onReady(document) {
    // Sub menus.

    $('.desktop-nav li.level-1.has-childs a').on('click', e => {
      window.location = $(e.target).attr('href');
    })

    // Footer menu accordion.
    $('.field_menus .field_title').on('click', function (event) {
      event.preventDefault();
      console.log('work');
      $(this).parents('.field_menus').toggleClass('active');
    });
  }

  onContent(context) {
    super.onReady();

    // Set the aria-label for the location type in location listing
    if($('.camc-locations-landing-page-form').length > 0){
      const locationButton = $('.camc-locations-landing-page-form .naked-form-select-wrap .toggle-dropdown');
      const locationButtonVal = locationButton.text();
      locationButton.attr('aria-label', locationButtonVal);
      locationButton.attr('aria-expanded', 'false');
      locationButton.on('click', function () {
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
      });
    }

    // Set the aria-label for the News category
    if($('.camc-news-landing-page-form').length > 0){
      const newsButton = $('.camc-news-landing-page-form .naked-form-select-wrap .toggle-dropdown');
      const newsButtonVal = newsButton.text();
      newsButton.attr('aria-label', newsButtonVal);
      newsButton.attr('aria-expanded','false');
      newsButton.on('click', function () {
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
      });
    }

    // Set the aria-label for the Contact us webform
    if($('.webform-submission-contact-us-form').length > 0){
      const webformLabelVal = $('.webform-submission-contact-us-form .form-item-i-would-like-to-send-a-message-to- label').text();
      const webFormButton = $('.webform-submission-contact-us-form .form-item-i-would-like-to-send-a-message-to- .naked-form-select-wrap .toggle-dropdown');
      webFormButton.attr('aria-label', webformLabelVal);
      webFormButton.attr('aria-expanded','false');
      webFormButton.on('click', function () {
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
      });
    }

    // Set the aria-label for the Providers sorting
    if($('form[data-drupal-selector="camc-doctor-landing-page-form"]').length > 0){
      const providerButton = $('form[data-drupal-selector="camc-doctor-landing-page-form"] .search__filters-sort .naked-form-select-wrap .toggle-dropdown');
      providerButton.attr('aria-label',Drupal.t('Sort By'));
      providerButton.attr('aria-expanded','false');
      providerButton.on('click', function () {
        const isExpanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !isExpanded);
      });
    }

    // Populate the mobile nav layout
    if (!$('.mobile-nav-layer .navigation').length) {
      const mainMenu = $('.header .navigation').clone();
      const mainMenuTop = $('.header .col-xs-80 > nav').clone();

      // Fix double id accesibility.
      mainMenu.find('#block-utilitynavigation').attr('id', 'block-utilitynavigation-mobile').attr('aria-labelledby', 'block-utilitynavigation-menu-mobile');
      mainMenu.find('#block-utilitynavigation-menu').attr('id', 'block-utilitynavigation-menu-mobile');
      mainMenu.find('#block-topnav').attr('id', 'block-topnav-mobile').attr('aria-labelledby', 'block-topnav-menu-mobile');
      mainMenu.find('#block-topnav-menu').attr('id', 'block-topnav-menu-mobile')
      mainMenu.find('.has-childs.level-1[role="button"]').removeAttr('role').removeAttr('aria-pressed');
      mainMenu.find('#block-hfsmenu').attr('id', 'block-hfsmobilemenu').attr('aria-labelledby','block-hfsmenu-mobile-menu');
      mainMenu.find('#block-hfsmenu-menu').attr('id', 'block-hfsmenu-mobile-menu');
      mainMenuTop.attr('id', 'block-microsite-topmenu-mobile-menu').attr('aria-labelledby','block-microsite-topmenu-mobile-menu');
      mainMenuTop.attr('class', 'contextual-region microsite-topmenu-mobile-menu');
      mainMenu.appendTo('.mobile-nav-layer');
      mainMenuTop.appendTo('.mobile-nav-layer');
    }

    // Header mobile menu toggle
    let width = window.innerWidth;

    const openMenu = () => {
      const isWv = $('body').hasClass('site-wvhealthnetwork');
      width = window.innerWidth;
      gsap.set(".mobile-nav-layer", {
        display: 'block',
      });
      if (isWv) {
        gsap.set("#block-sitebranding a", {
          zIndex: 4000,
        });
        gsap.to(".mobile-nav-layer", 0.1, {
          opacity: 1,
          onComplete: () => {
            $('html').addClass('mobile-menu-open');
          }
        });
      } else {
        gsap.to(".mobile-nav-layer", 0.3, {
          x: 0,
          onComplete: () => {
            $('html').addClass('mobile-menu-open');
          }
        });
      }
      $('.mobile-nav-layer').addClass('active');
    };

    const closeMenu = () => {
      const isWv = $('body').hasClass('site-wvhealthnetwork');
      width = window.innerWidth;
      if (isWv) {
        gsap.to(".mobile-nav-layer", 0.1, {
          opacity: 0,
          onComplete: () => {
            if (!$('.mobile-nav-layer').hasClass('active')) {
              setTimeout(() => {
                $('.mobile-nav-layer').css('display', 'none');
                gsap.set("#block-sitebranding a", {
                  zIndex: 500,
                });
              }, 350);
            }
          },
        });
      } else {
        gsap.to(".mobile-nav-layer", 0.3, {
          x: width,
          onComplete: () => {
            if (!$('.mobile-nav-layer').hasClass('active')) {
              setTimeout(() => {
                $('.mobile-nav-layer').css('display', 'none');
              }, 350);
            }
          },
        });
      }
      $('.mobile-nav-layer').removeClass('active');
      $('html').removeClass('mobile-menu-open');
    }

    $('.header .menu-toggle').on('click', (event) => {
      event.preventDefault();
      openMenu();
    });

    $('.mobile-nav-close').on('click', (event) => {
      event.preventDefault();
      closeMenu();
    });

    // Move sidebar cta bellow header.
    if ($('.field_sidebar_ctas').length > 0) {
      const nodeType = drupalSettings.nodeType;
      if ($('.no-hero').length > 0) {
        $('.sidebar-cta').addClass('sidebar_cta--no-hero');
      }
      const setDesktopPosition = (margin) => {
        const sidebarCta = document.querySelector('.sidebar-cta');
        if (typeof margin !== 'undefined') {
          sidebarCta.style.marginTop = `${margin}px`;
        } else {
          // Checking for the Node Type.
          if (nodeType !== 'clinical_trials') {
            sidebarCta.style.marginTop = `${(74 + (sidebarCta.getBoundingClientRect().height / 2)) * -1}px`;
          } else {
            // Removing marginTop for the clinical trials node.
            sidebarCta.style.marginTop = `${0}px`;
          }
        }
      };

      this.enquireRegister('camc_camc.md', () => {
        setDesktopPosition();
      }, () => {});
      this.enquireRegister('camc_camc.sm-max', () => {
        $('.field_sidebar_ctas').detach().prependTo('.main-column');
        setDesktopPosition(0);
      }, () => {
        $('.field_sidebar_ctas').detach().prependTo('.sidebar-column');
        setDesktopPosition();
      });
    }

    // Enable modals.
    MicroModal.init({
      onShow: modal => console.info(`${modal.id} is shown`), // [1]
      onClose: modal => console.info(`${modal.id} is hidden`), // [2]
    });
  }

  enquireRegister(breakpointName, match, unmatch) {
    const breakpoints = this.settings.breakpoints;
    const createHandler = (breakpoint, m, u) => {
      return [
        breakpoint.query,
        {
          match: m,
          unmatch: u,
        }
      ];
    };

    enquire.register.apply(enquire, createHandler(breakpoints[breakpointName], match, unmatch));
  }

}

DrupalBehavior.register('ctek_child_theme', 'global', CTEKChildTheme);

/**
 * Accordion functionality for Clinical Trials Category field.
 */
Drupal.behaviors.ClinicalTrialsFilterCategoryAccordion = {
  attach: function (context, settings) {
    once('ctCategoryAccordion', '#edit-field-categories-target-id .nested-li', context).forEach((item) => {
      const accordionGroup = item.querySelector('ul');

      // Add aria-hidden attribute to sub lists.
      item.querySelector('ul').setAttribute('aria-hidden', 'true');

      // Expand accordion when a child item is selected.
      if (item.querySelectorAll('ul li.active').length) {
        item.querySelector('span.icon-placeholder').setAttribute('aria-expanded', 'true');
        item.querySelector('ul').setAttribute('aria-hidden', 'false');
      }

      // Accordion button click event.
      item.querySelector('span.icon-placeholder').addEventListener('click', (el) => {
        // Update aria-expanded attribute on accordion trigger element.
        const expandAccordionEl = el.target.getAttribute('aria-expanded') === 'true';
        el.target.setAttribute('aria-expanded', !expandAccordionEl);

        // Update aria-hidden attribute on accordion trigger element.
        const showAccordionGroup = accordionGroup.getAttribute('aria-hidden') === 'true';
        accordionGroup.setAttribute('aria-hidden', !showAccordionGroup);
      })
    });
  }
}
